export class ActividadEconomicaEmisor {
   emisorId: string;
   actividadEconomicaId: string;
}
